import React, { useEffect } from 'react';
import classes from './errorComponent.module.scss';
import { useNavigate, useLocation } from 'react-router';
import content from './errorContent';

const SUPPORT_FORM_URL = import.meta.env.VITE_SUPPORT_FORM_URL;

// Types that show the support form page
const SUPPORT_FORM_TYPES = ['bad-request', 'verificationError'];

const ErrorPage = (props) => {
  const { type, mode = 'error' } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { heading, description } = location.state || {};

  const isSupportFormType = SUPPORT_FORM_TYPES.includes(type);
  const errorContent = content[type] || content['unauthorized'];

  useEffect(() => {
    sessionStorage.removeItem('sessionToken');
  }, []);

  const handleGoToForm = () => {
    window.open(SUPPORT_FORM_URL, '_blank');
  };

  const handleReturnHome = () => {
    navigate('/');
  };

  // Support form error page (for types that require a support form)
  if (isSupportFormType) {
    return (
      <div className={classes.container}>
        <div className={classes.textContainer}>
          <span className={classes.errorHeading}>
            {heading || errorContent['heading']}
          </span>
          <span className={classes.errorText}>
            {description || errorContent['description']}
          </span>
          {errorContent['supportHours'] && (
            <span className={classes.supportHours}>
              {errorContent['supportHours']}
            </span>
          )}
          <button className={classes.primaryButton} onClick={handleGoToForm}>
            File a Support Ticket
          </button>
          <button className={classes.primaryButton} onClick={handleReturnHome} style={{ marginTop: '1rem' }}>
            {errorContent['primaryButtonText']}
          </button>
        </div>
      </div>
    );
  }

  // Default error page (for types that do not require a support form)
  return (
    <div className={classes.container}>
      <div className={classes.textContainer}>
      <span className={classes.errorHeading}>
      {/* <span className={mode === 'error' ? classes.errorHeading : classes.successHeading}> */}
          {heading || errorContent['heading']}
        </span>
        <span className={classes.errorText}>
          {description || errorContent['description']}
        </span>
        <button className={classes.primaryButton} onClick={handleReturnHome}>
          {errorContent['primaryButtonText']}
        </button>
      </div>
    </div>
  
  )
}

export default ErrorPage;